import type { FeatureFlagDecision, FeatureFlagKey } from '@/api/feature-flags';

import { useFeatureFlags } from './use-feature-flags';

const defaultDecision = (flag: FeatureFlagKey): FeatureFlagDecision => ({
    flag,
    enabled: false,
    reason: 'default',
});

export function useFeatureFlag(flag: FeatureFlagKey) {
    const { flags, isLoading, isFetching, isError, error, refetch } = useFeatureFlags();
    const decision = flags[flag] ?? defaultDecision(flag);

    return {
        ...decision,
        decision,
        isLoading,
        isFetching,
        isError,
        error,
        refetch,
    };
}
